module.exports = __webpack_public_path__ + "img/40_00_072_829.58e62f98.jpg";